/**
 * Minimale afname en bestellen per printvel afdwingen, zonder externe app.
 *
 * De snippet `minimum-quantity` zet het minimum al als `min` op elk aantalveld, maar het
 * thema verstuurt zijn formulieren met `novalidate` en een eigen fetch, dus de browser
 * controleert dat minimum nooit. Dit script bewaakt de plekken waar een ongeldig aantal
 * alsnog binnenkomt:
 *
 *   1. het aantalveld zelf, zodat ook "Koop nu" en de wallet-knoppen een geldig aantal
 *      meesturen: het veld kan daardoor nooit een ongeldige waarde vasthouden;
 *   2. het toevoegen aan de winkelwagen, als iets de waarde alsnog omzeilt;
 *   3. het afrekenen, voor regels die er langs een andere weg in zijn gekomen.
 *
 * Het minimum komt per veld uit het `min` attribuut. Uitzonderingen zoals de feestdoosjes
 * krijgen daar 1, en lopen hier dus vanzelf goed.
 *
 * Koekjes met foto gaan per printvel: hun veld heeft een `data-order-multiple` (12), en een
 * aantal moet daar een veelvoud van zijn. Een tussenliggend aantal wordt naar boven
 * afgerond, zodat een klant nooit minder krijgt dan hij invulde.
 */
(function () {
  'use strict';

  var configElement = document.querySelector('[data-minimum-quantity-config]');
  if (!configElement) return;

  var CONFIG;
  try {
    CONFIG = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }
  if (!CONFIG || !CONFIG.enabled) return;

  var CART_QTY = 'input[name="updates[]"]';
  var ADD_TO_CART_FORM = 'form[action*="/cart/add"]';
  var ALERT_CLASS = 'ss-min-qty-alert';
  var FLAG_CLASS = 'ss-min-qty-flag';

  function closest(node, selector) {
    return node && node.closest ? node.closest(selector) : null;
  }

  /* Het `min` attribuut is de bron: MQuantityInput werkt het bij zodra de variant of het
     aantal in de winkelwagen verandert, dus het is actueler dan `data-min`. */
  function minimumOf(input) {
    var min = parseInt(input.getAttribute('min'), 10);
    return isNaN(min) || min < 1 ? 1 : min;
  }

  function multipleOf(input) {
    var multiple = parseInt(input.getAttribute('data-order-multiple'), 10);
    return isNaN(multiple) || multiple < 2 ? 1 : multiple;
  }

  /* "12, 24, 36" voor in de meldingen. */
  function seriesOf(multiple) {
    return [multiple, multiple * 2, multiple * 3].join(', ');
  }

  function fill(template, values) {
    return String(template || '')
      .replace(/\[aantal\]/gi, values.aantal == null ? '' : values.aantal)
      .replace(/\[reeks\]/gi, values.reeks == null ? '' : values.reeks)
      .replace(/\[product\]/gi, values.product == null ? '' : values.product)
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function productMessage(input) {
    var multiple = multipleOf(input);
    if (multiple > 1) {
      return fill(CONFIG.messages.multipleProduct, { aantal: multiple, reeks: seriesOf(multiple) });
    }
    return fill(CONFIG.messages.product, { aantal: minimumOf(input) });
  }

  function cartMessage(input) {
    var multiple = multipleOf(input);
    if (multiple > 1) {
      return fill(CONFIG.messages.multipleCart, {
        aantal: multiple,
        reeks: seriesOf(multiple),
        product: titleOf(input)
      });
    }
    return fill(CONFIG.messages.cart, { aantal: minimumOf(input), product: titleOf(input) });
  }

  function titleOf(input) {
    var row = closest(input, '.m-cart-item, .m-cart-drawer-item, li, tr');
    var link = row && row.querySelector('.m-cart-item__title');
    return link ? link.textContent.trim() : '';
  }

  function toast(message, input) {
    var notification = window.MinimogTheme && window.MinimogTheme.Notification;
    if (!notification || typeof notification.show !== 'function') return;

    var target =
      closest(input, '.m-main-product--info') &&
      closest(input, '.m-main-product--info').querySelector('.m-product-form-message');

    notification.show({
      target: target || document.body,
      method: 'appendChild',
      type: 'warning',
      message: message,
      last: 4000,
      sticky: !target
    });
  }

  /**
   * Het dichtstbijzijnde geldige aantal op of boven de invoer, of null als de invoer al
   * klopt. Nul blijft nul: dat is hoe een klant een regel uit de winkelwagen haalt.
   */
  function correctedValue(input) {
    var value = parseInt(input.value, 10);
    if (isNaN(value) || value === 0) return null;

    var corrected = Math.max(value, minimumOf(input));
    var multiple = multipleOf(input);
    if (multiple > 1) corrected = Math.ceil(corrected / multiple) * multiple;

    return corrected === value ? null : corrected;
  }

  /* Zet een ongeldig aantal recht. Geeft true terug als er iets veranderd is. */
  function clamp(input) {
    var corrected = correctedValue(input);
    if (corrected === null) return false;

    input.value = corrected;
    return true;
  }

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input || !input.name) return;

      var isProductQty = input.name === 'quantity' && closest(input, ADD_TO_CART_FORM + ', m-quantity-input');
      if (!isProductQty && input.name !== 'updates[]') return;

      if (clamp(input)) toast(productMessage(input), input);
    },
    true
  );

  /* Vangnet: het aantal kan ook programmatisch gezet zijn, zonder change event. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches(ADD_TO_CART_FORM) || !form.elements) return;

      var field = form.elements.namedItem('quantity');
      if (field && !field.tagName) field = field[0];
      if (!field) return;

      if (clamp(field)) toast(productMessage(field), field);
    },
    true
  );

  /* De "Koop nu" en wallet-knoppen lezen het formulier zelf uit, dus corrigeer vlak
     voordat Shopify dat doet. */
  document.addEventListener(
    'click',
    function (event) {
      var button = closest(event.target, '.shopify-payment-button');
      if (!button) return;

      var form = closest(button, 'form');
      var field = form && form.elements ? form.elements.namedItem('quantity') : null;
      if (field && !field.tagName) field = field[0];
      if (!field) return;

      if (clamp(field)) toast(productMessage(field), field);
    },
    true
  );

  function existingAlert(checkoutButton) {
    var anchor = closest(checkoutButton, '.m-cart__checkout-button') || checkoutButton;
    var previous = anchor.previousElementSibling;
    return previous && previous.classList.contains(ALERT_CLASS) ? previous : null;
  }

  function alertFor(checkoutButton) {
    var found = existingAlert(checkoutButton);
    if (found) return found;

    var anchor = closest(checkoutButton, '.m-cart__checkout-button') || checkoutButton;
    var element = document.createElement('p');
    element.className = ALERT_CLASS;
    element.setAttribute('role', 'alert');
    anchor.parentNode.insertBefore(element, anchor);
    return element;
  }

  /**
   * Regels met een ongeldig aantal: onder hun minimum, of geen veelvoud van hun printvel.
   * Alleen binnen het formulier van deze afrekenknop, zodat de winkelwagenpagina en het
   * winkelwagenpaneel elkaar niet in de weg zitten.
   */
  function invalidLines(checkoutButton) {
    var scope = checkoutButton.form || closest(checkoutButton, 'form') || document;
    if (!scope.querySelector(CART_QTY)) scope = document;

    return Array.prototype.filter.call(scope.querySelectorAll(CART_QTY), function (input) {
      return correctedValue(input) !== null;
    });
  }

  function blockCheckout(checkoutButton) {
    var offenders = invalidLines(checkoutButton);

    document.querySelectorAll('.' + FLAG_CLASS).forEach(function (input) {
      input.classList.remove(FLAG_CLASS);
    });

    if (!offenders.length) {
      var stale = existingAlert(checkoutButton);
      if (stale) stale.remove();
      return false;
    }

    offenders.forEach(function (input) {
      input.classList.add(FLAG_CLASS);
    });

    var first = offenders[0];
    var element = alertFor(checkoutButton);
    element.textContent = cartMessage(first);

    first.scrollIntoView({ block: 'center', behavior: 'smooth' });
    return true;
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = closest(event.target, '[name="checkout"]');
      if (!button) return;

      if (blockCheckout(button)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;

      if (blockCheckout(submitter)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
})();
